var styleDataHash = "90ee72b5";
const injectCss = (() => {
  var css = `@charset "UTF-8";.WmzU7,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.haZBx{align-items:center;background:transparent;border:transparent;border-radius:var(--ricos-internal-toolbar-button-border-radius,6px);color:var(--ricos-internal-toolbar-button-text-color,#000);cursor:pointer;display:flex;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px;gap:3px;height:30px;justify-content:center;margin:0;min-width:30px}.haZBx:hover:not([disabled]){background-color:var(--ricos-internal-toolbar-button-background-color-hover,#e7f0ff);color:var(--ricos-internal-toolbar-button-text-color-hover,#116dff)}.haZBx.iKFFf{background-color:var(--ricos-internal-toolbar-button-background-color-active,#d6e6fe);color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}.haZBx.iKFFf svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}.haZBx.Ea54N{cursor:default;opacity:.4;pointer-events:none}.haZBx._5G9lW:not(.iKFFf):hover{background-color:unset}.haZBx._5G9lW{height:36px;min-width:36px}.haZBx:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var toolbar_button_default = {
  "fontElementMap": "WmzU7",
  "toolbarButton": "haZBx",
  "active": "iKFFf",
  "disabled": "Ea54N",
  "mobileToolbarButton": "_5G9lW"
};
export {
  toolbar_button_default as default,
  injectCss
};
//# sourceMappingURL=toolbar-button-scss.js.map
